import request from '@/utils/request'
import API from './api'

/*题型相关*/

//英语-选择题、判断题 获取题型可用模板列表
export const getQuestionTempListAPI = (data) => {
	return request({
		url: API.GET_QUESTION_TEMP_LIST,
		method: 'post',
	    data
	});
}
/*题目编辑*/

// 语文保存新题
export const saveNewQuestionAPI = (data) => {
	return request({
		url: API.SAVE_NEW_QUESTION,
	    method: 'post',
	    data
	});
}

export const qshowAddQuestionAPI = (data) => {
	return request({
		url: API.QSHOW_QUESTION_ADD,
		method: 'post',
		data
	});
}


//题目管理改题校验
export function modifyQualityQuestionCheckAPI(data){
	return request({
		url: API.MODIFY_QUALITY_QUESTION_CHECK,
		method: 'post',
	    data
	});
}

//题目管理-模板管理-获取模板列表
export const getAllQuestionTempListAPI = (data) => {
	return request({
		url: API.GET_ALL_QUESTION_TEMP_LIST,

	    method: 'post',
	    data
	});
}

//录题校验
export function addQuestionCheckAPI(data){
	return request({
		url: API.ADD_QUESTION_CHECK,
		method: 'post',
	    data
	});
}

//题目管理-模板管理-模板状态修改：启用、停用、删除
export const modifyTempStatusAPI = (modifyType,data) => {
	let url=modifyType=='delete'?API.DELETE_QUESTION_TEMP:API.MODIFY_TEMP_STATUS
	if (modifyType=='able') {
		data.stage='1'
	} else if(modifyType=='disable'){
		data.stage='0'
	}
	return request({
		url,
	    method: 'post',
	    data
	});
}

//题目管理-模板管理-创建人列表
export const getTempUserListAPI = (data) => {
	return request({
		url: API.GET_TEMP_USER_LIST,
	    method: 'post',
	    data
	});
}


//题目管理改题
export function modifyQualityQuestionAPI(data){
	return request({
		url: API.MODIFY_QUALITY_QUESTION,
	  	method: 'post',
	    data
	});
}

// 添加/编辑模版
export const setAddEditTemplateAPI = (data) => {
	return request({
		url: API.ADD_EDIT_TEMPLATE,
	    method: 'post',
	    data
	});
}


//题盒子录题
export function addQuestionAPI(data){
	return request({
		url: API.ADD_QUESTION,
		method: 'post',
	    data
	});
}

// 添加引导语
export const addGuideAPI = (data) => {
	return request({
		url: API.ADD_GUIDE,
	    method: 'post',
	    data
	});
}

// 获取模版详情
export const getTemplateDetailAPI = (data) => {
	return request({
		url: API.GET_TEMPLATR_DETAIL,
	    method: 'post',
	    data
	});
}


//获取语文阅读分类标签
export const getCategoryLabelListAPI = (data) => {
	return request({
		url: API.LOOKOVER_WORD_BANK,
	    method: 'post',
	    data
	});
}

//添加语文阅读分类标签
export const createCategoryLabelAPI = (data) => {
	return request({
		url: API.CREATE_CATEGORY_LABEL,
	    method: 'post',
	    data
	});
}

//删除语文阅读分类标签
export const deleteCategoryLabelAPI = (data) => {
	return request({
		url: API.DELETE_CATEGORY_LABEL,
	    method: 'post',
	    data
	});
}

//英语词库管理编辑
export const editCateItemAPI = (data) => {
	return request({
		url: API.EDIT_CATE_ITEM,
	    method: 'post',
	    data
	});
}

//英语词库删除
export const deleteCateItemAPI = (data) => {
	return request({
		url: API.DELETE_CATE_ITEM,
	    method: 'post',
	    data
	});
}




// WEBPACK FOOTER //
// ./src/API/question-editor.js